@if (dialogOpened()) {
  <div
    class="fixed top-0 left-0 z-50 grid h-full w-full place-items-center"
    [ngClass]="blurBackground() ? 'bg-black/30' : ''"
    (click)="cancelOnOutsideClick($event)">
    <div
      class="flex flex-col rounded-xl bg-white"
      [style]="{ width: width() + 'px', 'max-height': '70vh' }">
      <div
        class="flex items-center justify-between border-b border-[#D5DED9] p-4 text-xl font-medium">
        <span class="font-bold">{{ title() }}</span>
        @if (!acknowledgeOnly()) {
          <button class="grid place-items-center transition" (click)="cancel()">
            <span class="material-icons">close</span>
          </button>
        }
      </div>
      <div class="m-5 overflow-y-auto">
        <ng-content></ng-content>
      </div>
      @if (withButtonBar()) {
        <div
          class="grid justify-end border-t border-[#D5DED9]"
          [ngClass]="acknowledgeOnly() ? 'grid-cols-1' : 'grid-cols-2'">
          @if (!acknowledgeOnly()) {
            <button
              id="cancel-button"
              type="submit"
              class="w-full bg-white p-[1.5rem] text-sm font-bold uppercase transition hover:brightness-90"
              (click)="hasSecondaryCta() ? confirmOnSecondaryCta() : cancel()">
              {{ cancelButtonText() }}
            </button>
          }
          <button
            id="confirm-button"
            type="submit"
            class="bg-primary w-full p-6 text-sm font-bold text-white uppercase transition hover:brightness-90 disabled:opacity-60"
            [ngClass]="{ 'acknowledge-only': acknowledgeOnly() }"
            (click)="confirm()"
            [disabled]="isConfirmDisabled()"
            [appTooltip]="isConfirmDisabled() ? confirmDisabledTooltip() : ''"
            [position]="confirmDisabledTooltipPosition()">
            {{ confirmButtonText() }}
          </button>
        </div>
      }
    </div>
  </div>
}
